import fetch from '../utils/fetch';
import CustomError from '../utils/CustomError';
import { getCompaniesEndPointV3 } from '../constants/endpoints';
import {
  UNEXPECTED_ERROR,
  SEARCH_COMPANIES_SUCCESS,
  CREATE_COMPANY_ERROR,
  UPDATE_COMPANY_ERROR,
  DELETE_COMPANY_ERROR,
  CREATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_SUCCESS,
  DELETE_COMPANY_SUCCESS,
  GET_SINGLE_COMPANY_SUCCESS,
  TRANSACTION_ID
} from '../constants/services';

import { COMPANY_PAGE_SIZE } from '../constants/companies';

export async function searchCompanies(
  token,
  param,
  start,
  includePulseData = false
) {
  try {
    const params = {
      includePulseData,
      ...(param
        ? { start: 0, limit: COMPANY_PAGE_SIZE, qname: param }
        : { start: start || 0, limit: COMPANY_PAGE_SIZE })
    };
    const query = await fetch(getCompaniesEndPointV3, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_COMPANIES_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function getCompany(token, companyId) {
  try {
    const query = await fetch(`${getCompaniesEndPointV3}/${companyId}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: GET_SINGLE_COMPANY_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function updateCompany(token, companyId, data) {
  try {
    const query = await fetch(`${getCompaniesEndPointV3}/${companyId}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...UPDATE_COMPANY_ERROR, transactionId });
    }
    return {
      status: UPDATE_COMPANY_SUCCESS,
      data: json.data
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function createCompany(token, data) {
  try {
    const query = await fetch(getCompaniesEndPointV3, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...CREATE_COMPANY_ERROR, transactionId });
    }
    return {
      status: CREATE_COMPANY_SUCCESS,
      data: json.data
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function deleteCompany(token, companyId) {
  try {
    const query = await fetch(`${getCompaniesEndPointV3}/${companyId}`, {
      method: 'delete',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...DELETE_COMPANY_ERROR, transactionId });
    }
    return {
      status: DELETE_COMPANY_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}
